module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "80px",
      "size": "mini"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名"
    }
  }, [_c('el-input', {
    staticClass: "k",
    attrs: {
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.form.userid),
      callback: function($$v) {
        _vm.$set(_vm.form, "userid", $$v)
      },
      expression: "form.userid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    staticClass: "k",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "native-type": "submit",
      "icon": "el-icon-search"
    }
  }, [_vm._v("登陆")])], 1), _vm._v(" "), _c('el-form-item', [_c('p', {
    staticStyle: {
      "line-height": "22px",
      "overflow": "hidden",
      "font-size": "12px"
    }
  }, [_vm._v("\n        如果您还不是我司会员，请"), _c('a', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#06F"
    },
    attrs: {
      "href": "http://xy56.kingtrans.cn/reg.jsp",
      "target": "_blank"
    }
  }, [_vm._v("立即注册")]), _vm._v("成为我司会员享更多优惠！")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "xy-title"
  }, [_c('b', [_vm._v("客户登陆")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31e0e7c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/xy-login-form.vue
// module id = 719
// module chunks = 1